import React from "react";
import { CORRUPT_FILE } from "../../actions/actionTypes";
import { useDispatch } from "react-redux";
import { useFileRemoval } from "../../helpers/useFileRemoval";
import ErrorPopup from "./ErrorPopup";

const CorruptFile = ({
  allFiles,
  setAllFiles,
  allProcessedFiles,
  setAllProcessedFiles
}) => {
  const dispatch = useDispatch();

  const { handleDelete, redirectToUpload } = useFileRemoval({
    allFiles,
    setAllFiles,
    allProcessedFiles,
    setAllProcessedFiles,
  });

  const onTryAgain = () => {
    dispatch({ type: CORRUPT_FILE, payload: false });
    handleDelete();
    redirectToUpload();
  };

  return (
    <ErrorPopup onTryAgain={onTryAgain}>
      <div className="upload-title-text">
        Upload failed!
      </div>
      <div className="upload-content-text">
        The PDF File is empty/corrupt.
      </div>
    </ErrorPopup>
  );
};

export default CorruptFile;
